module.exports = {
  "menuManager": {
    "tenantMenu": "租户菜单",
    "menuManager": "菜单管理",
    "menuList": "菜单列表",
    "menuName": "菜单名称",
    "menuNameHint": "请输入菜单名称",
    "editMenu": "编辑菜单",
    "addMenu": "新增菜单",
    "fatherMenu": "上级菜单",
    "fatherMenuHint": "请选择上级菜单",
    "routeName": "路由名称",
    "routeNameHint": "请输入路由名称",
    "routePath": "路由地址",
    "routePathHint": "请输入路由地址",
    "viewSort": "显示排序",
    "viewSortHint": "请输入显示排序",
    "menuType": "菜单类型",
    "menuTypeHint": "请选择菜单类型",
    "directory": "目录",
    "menu": "菜单",
    "button": "按钮",
    "permissionCharacters": "权限字符",
    "permissionCharactersHint": "请输入权限字符",
    "menuIcon": "菜单图标",
    "menuIconHint": "请上传菜单图标",
    "addMenuHint": "请在右侧输入要新增的菜单信息，然后点击保存",
    "deleteMenuHint": "被删除的菜单将不可恢复，确定吗"
  },
};


// WEBPACK FOOTER //
// ./src/i18n/menuManager/en.js